// Generated by GitHub Copilot
import { createFileRoute } from '@tanstack/react-router'
import { PersonalPreferencesPanel } from '#components/domain/auth/user/shared/personal-preferences-panel.tsx'

export const Route = createFileRoute('/_appSettings/$companyId/settings/user')({
    component: PersonalPreferencesPanel,
})
